import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { makeStyles } from '@mui/styles';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { withStyles } from '@mui/styles';
import {httpClient} from "../../core/HttpClient";
import Avatar from "@mui/material/Avatar";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import liff from "@line/liff";

const theme = createTheme({
    palette: {
        primary: {
            main: '#00B300',
            dark: '#00C900',
            contrastText: '#ffffff',
        },
    },
});

const ColorButton = withStyles((theme) => ({
    root: {
        color: '#FFFFFF',
        backgroundColor: '#00C300',
        '&:hover': {
            backgroundColor: '#00E000',
        },
        '&:active': {
            backgroundColor: '#00B300',
        },
    },
}))(Button);

const useStyles = makeStyles({
    root: {
        maxWidth: 600,
        width: '100%'
    },
    media: {
        height: 0,
        paddingTop: '52.35%', // 1.91:1 Facebook OG Image
    },
});

// const liff = window.liff;
const lineAuthentication = async(cb) => {
    const liffId = process.env.REACT_APP_LINE_SIGNIN_LIFF_ID;
    await liff.init({ liffId: liffId, withLoginOnExternalBrowser: true }).catch(err=>{throw err});
    if (liff.isLoggedIn()) {
        const accessToken = await liff.getAccessToken();
        return cb(accessToken);
    }else{
        return cb(null);
    }
};

export default function UserInvite() {
    const { t } = useTranslation();
    const classes = useStyles();
    const { key } = useParams();
    const [command, setCommand] = useState(null);
    const [loading, setLoading] = useState(true);
    const [liffClient, setLiffClient] = useState(false);

    useEffect(() => {
        console.log('[UserInvite]');
        lineAuthentication(accessToken=>{
            const url = process.env.REACT_APP_API_BASE_URL + '/commands/INVITE_USER/' + key;
            httpClient.get(url)
                .then(res => {
                    let result = res.data;
                    console.log('result', result);
                    if (result && result.data && result.data.account) {
                        let name = result.data.account.name.i18n['th'] || result.data.account.name.i18n['en'];
                        let imageUrl = `${process.env.REACT_APP_CDN_BASE_URL}/public/assets/empty.png`;
                        if(result.data.account.image){
                            imageUrl = `${process.env.REACT_APP_CDN_BASE_URL}/${result.data.account.image.permission}/merchant/o/${result.data.account.image.name}`;
                        }
                        let role = result.data.role;
                        setCommand({key: result.key, name: name, imageUrl: imageUrl, role: role});
                    }

                    if (liff.isInClient()) {
                        setLiffClient(true);
                    }

                    setLoading(false);
                });
        });
    }, [key]);

    const handleClick = () => {
        console.log('handleClick');
        liff.login({redirectUri: `${process.env.REACT_APP_BASE_URL}/signin/invite/${key}`});
    };

    const handleAccept = () => {
        console.log('handleAccept');
        window.location.href = `${process.env.REACT_APP_BASE_URL}/signin/invite/${key}`;
    };

    return (
        <Box>
            {loading &&
            <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress size={20}/>
            </Box>
            }
            <Box display="flex" justifyContent="center" p={2} mt={2}>
            {!loading &&
                <>
                    {command &&
                    <Card className={classes.root}>
                        <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                            <Avatar sx={{ width: 168, height: 168 }}
                                    alt="Shop"
                                    variant={"square"}
                                    src={command.imageUrl} />
                        </Box>
                        <CardContent>
                            <Box display="flex" justifyContent="center" alignItems="center">
                                <Typography gutterBottom  variant="h6" component="h3">
                                    {command.name}
                                </Typography>
                            </Box>
                        </CardContent>
                        <CardActions>
                            {liffClient &&
                            <ColorButton
                                variant="contained"
                                disableElevation
                                size="large"
                                fullWidth={true}
                                onClick={(e) => handleAccept(e)}
                            >
                                {t('login.title')}
                            </ColorButton>
                            }
                            {!liffClient &&
                                <ThemeProvider theme={theme}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disableElevation
                                        size="large"
                                        fullWidth={true}
                                        className={classes.button}
                                        disabled={loading.update}
                                        onClick={(e) => handleClick(e)}
                                        startIcon={<img style={{width: '32px'}} alt="LINE" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAYAAABxlTA0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3NpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDphNTk0YTczYS0zNzEzLTRhMjktODgyYi0xYjg0ZWJkMjM5NGQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6N0ZBREEwQjU5M0YxMTFFNDk1OEFENjBBMUJBQjkyMzkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6N0ZBREEwQjQ5M0YxMTFFNDk1OEFENjBBMUJBQjkyMzkiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MmIxZTVlMTEtNGMwMC00NDUxLTk0NGQtZDBlZWM0ZmYwMTViIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOmE1OTRhNzNhLTM3MTMtNGEyOS04ODJiLTFiODRlYmQyMzk0ZCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhVDLOQAAAYeSURBVHja7Fx7iBVVGP/urq6tWRuJoUumZYpoRiWWlaBEgr3sJZpIsRQ9zKK0IoUIevxhFAaB2UPsTa5lSxaiwdrbLCOTDJPKrY22slbX2nxsubffx3wXpsvsvWfO3Jk5Z+75wY+9d/acMzO/e+Y73/nONyeXz+fJIT7UOAmcwE5gByewE9gJ7OAEdgI7gR2cwE5gByewEzg76Gf49R0DjgCHggPAgWAOPALuBw+CbeCvYK8TuDRGg+eCk4T8/XjFuj1gO7gN3Ap+Bn4KHkr7pnIpx4PPA+eAM8GRFW77ALgJbAHXSo+vCoG5VzaBN4JjEzpnN/g6+JT07EwKPARcCN4mtjUtvAs+AL6fFYH7g3eC94ODDLL5G8Dbwe9sFngyuBIcb6iXchhcCj4M/muTwOxf3ws+aIEryPgEnAv+aIPADeBqcIZlc4Iu8GrxPIwVeBi4EZxg6cSrRzycV00UmL2Ej2WCYDPyIvKLJgncIO7PmRkJIfBU/CpwnQkCc2xgvYU2V2UmOEWm35FG+6hYnEFxGQNlsD42zR48UaaetZRdPAden4bAbBo2y2Qiy2CBOCi1JWkTcV0ViFvoSE/K38R6MJ9sBziOqgczxMdPpAdfUmXiMhYlaSKaFMvxkg4H1E8nL3pVDo+RFxha7DvGQZibyYsdP1+i7lfkrYhMB3/2HX9c6o7qg9PIW3YqB273lPAWHCYiJOvB7rwaVvrqjS5TthPM+cpvl+MbfMdqwQ/7qH+Fr9xCX5s1Cve0QPF+7gqrl04PvgA8WrHs777Pe8qU7ZYRu4A/5W9n0QxrHrg3oP4fvs+/+dpUWQwdGcIOh4JOKHFiyrawXfzSFo2R/ZYAMXnVerZi/cliVnvjFPgMAwacN8Hl5C0/hcE8mf7qYpD8IG2qFXRMhCnRsrujxgk0cXLcJmJIysLWi3fCyz28CvE5qa/18ary20XHxkvPronj/nUEPiplgZeB8+XzLvBWUo/dvlJiMF4Uh2Y6JuJgygJzr73B9/0l8IWIbYZZWT4Sdw9m92loyiI/IYGmnfJ9AThYoV5jwBPIk40lIe8/VoF/AcekLDDHapvBc+SJ+ltYDs0RvYiCmxirifjaEC9igtjjJNEb0pxo9eAvI1zc7oAfeDjpB+x54tBKXt6ZCjoCruGEEF7IdgqZsakj8EZNMf4Se1cMXij9KEKvelZctR8Uys4JOMZ5cusk6FMOrUlE09p9g0s5DFAow5OFLQG9uPC9ruh664rKHUdeHkP/gPPWKP7wLyveT0totTSiacz7FKNPu8CGMm2NAPeBveAUOTYOPCBt7AEb5fisEudaJtG4fhKBy0ub08qcn8u/pXAv3+hopbuiMUweyTqFsnvFdgX5j1z/LJ8N7JGnY4zM2MgXFfteBrZSvfJbqXei79g/4BfSU4Mwtqh8X+AJzYqwQkVZ9HyGvCTqakCHjB+HkrDBBTxEXnJGNWAJab7vEUXgn8jLFM86PpDpuBaiJp7UypT17IyKu1/cyDbdBqKmThWWcLoyKvD8KOJWQuBCJGpu2CiTBVhKFcgTrmR+cBO4ijQzYAzDazLry5skMInbtoLsTgbkVwguEp+cTBOYcSV5Kwf1ForLGfoXU8iYb9ICMyZJhOski8R9D7xMZo0VQ1zbGWwV96bZEnHXkJdU0l3phuPcL4JjENeAl0Z1dWLGo3Kdh+NoPKl3ldkec5LIPZT+sn8BnFTIr/guj/MkSb9tz1Gzm8SBPzVFcTvFDWuN+0Rp7RfBpmm6TFAuJy9onhR49WN2UmYrZ8AGzRwTnkreks1U8UDqYjoXh1jvoAR3QskZuAM2rxNy7PU08rIZ+VEeHrHNfTIJWpv0zeQs2GKce/PTpJ5VXwwON15LIfMZqklgBi9RdYSsw24Xb6fwCKUYiLJF4FoKt2EGr1JzkvbOtC/clo3pBiuW4/Qp3hfofBPELQwoNkAl6XmTDGS7TbpwW3pwqXfyukTYC00T13aBOddtlfyPN14ycjCxxUQ0Fn1/h7yXFbeZfuG2CPyGTD52SK/dbMl1W+OmWQu3f7AT2Ans4AR2AjuBHZzATmAnsIMT2Ans8D/8J8AALjKkOlxwuToAAAAASUVORK5CYII=" />}
                                    >
                                        {t('login.line')}
                                    </Button>
                                </ThemeProvider>
                            }
                        </CardActions>
                    </Card>
                    }
                    {!command &&
                    <Alert severity="warning">{t('common.message.invalidToken')}</Alert>
                    }
                </>
            }
            </Box>
        </Box>
    )
}